import { useContext, useState } from "react";
import { RootContext } from "../../../../stores";
import { ILogoutOrProfileSwitchRequiredFormValues } from "../../../../modules/authentication/_interfaces/ILogoutOrProfileSwitchRequiredFormValues";

export function useLogoutOrProfileSwitchRequiredController(
    values: ILogoutOrProfileSwitchRequiredFormValues,
    update: (patch: Partial<ILogoutOrProfileSwitchRequiredFormValues>) => void,
) {
    const rootStore = useContext(RootContext);
    const userStore = rootStore.userStore;
    const user = userStore.user;

    const [error, setError] = useState<string>();
    const [fieldErrors, setFieldErrors] = useState<Partial<Record<keyof ILogoutOrProfileSwitchRequiredFormValues, string>>>({});
    const [isSubmitting, setSubmitting] = useState(false);
    const [validationRun, setValidationRun] = useState(false);

    const switchToVolunteerProfile = async () => {
        const userVolunteerProfile = user.volunteerProfile;
        if (userVolunteerProfile?.id !== undefined) {
            await userStore.updateUserProfileStatus(user.id, userVolunteerProfile.id, 'active');
        }
    }

    const submit = async (override?: Partial<ILogoutOrProfileSwitchRequiredFormValues>) => {
        setSubmitting(true);
        setError(undefined);
        setValidationRun(true);

        try {
            const effectiveValues = {
                ...values,
                ...override
            }
            if (effectiveValues.logout) {
                update({ loading: true });
                const result = await rootStore.userStore.logout();
                update({ loading: false, logout: false });
            } else if (effectiveValues.switchProfiles) {
                update({ loading: true });
                if (!user.isVolunteerProfileActive) {
                    await switchToVolunteerProfile();
                }
                update({ loading: false, switchProfiles: false });
            }
        } catch {
            setError("An unknown error occurred");
        } finally {
            setSubmitting(false);
        }
    };

    return {
        values,
        onChange: update,
        onSubmit: submit,
        isSubmitting,
        error,
        fieldErrors
    };
}
